module.exports = __webpack_public_path__ + "img/abil_fatt_vis_invoiceweb.b98d73c7.png";